import { useQuery } from "@tanstack/react-query";
import { fetchCompanies } from "../services/companiesServices";
import { format, parse } from "date-fns";

const parseStartDateCreated = (dateString) => {
  const input = dateString; // DD/MM/YYYY
  const parsedDate = parse(input, "dd/MM/yyyy", new Date());
  if (isNaN(parsedDate)) {
    return null; // Handle invalid date
  }
  const output = format(parsedDate, "MM/dd/yyyy");

  return output;
};

const useCompanies = () => {
  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ["companies"],
    queryFn: fetchCompanies,
  });

  const formattedCompanies = data?.map(company => ({
    ...company,
    dateCreated: company.dateCreated ? parseStartDateCreated(company.dateCreated) : null,
   
  })) || [];
  return { companies: formattedCompanies, isLoading, isError, refetch };
};

export default useCompanies;
